import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import "../../css/errorRoute.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ErrorRoute = () => {
  const language = useSelector((state) => state.languagesState.languages);
  const history = useNavigate();
  const back = () => {
    history("/login");
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="md" className="text-center">
        <Grid container spacing={2}>
          <Grid size={12}>
            <div className="d-flex justify-content-center">
              <img src="/assets//images/signal-sight.png" alt="alt" width={400} height={200} />
            </div>
            <Typography variant="h6" className="py-3">
              {language?.error_page?.it_looks_like ?? "Oops! It looks like the page you're trying to reach doesn't exist or may have been moved."}
            </Typography>
            <Typography variant="h6" className="py-3">
              {language?.error_page?.dont_worry_though ?? "Don't worry though, you can use the navigation menu or the search bar to find what you're looking for. If you continue to have trouble, please contact our support team at"}
              <a className="px-2 errorAtag" href="mailto:info@signalsight.io">
                info@signalsight.io
              </a>{" "}
              {language?.error_page?.for_assistance ?? "for assistance"}
            </Typography>
            <button
              onClick={back}
              style={{ backgroundColor: "#729abf", color: "#ffff" }}
              className="btn my-4 px-5 py-2"
            >
              {language?.error_page?.back_home ?? "Back Home"}
            </button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ErrorRoute;
